import { gridUnit } from 'src/design/styleguide/common/measurements';

export const baseBreakpointGutter = gridUnit * 4;
